import {
    UserVisitTypeEnum,
    BreakTypeEnum,
    VisitStatusEnum
} from 'common/enums/VisitEnums';
import { TaskStatus } from 'common/models/internal/TaskVisit';
import { dashboardColors } from 'common/enums/ColorEnum';
import VisitUtils from 'common/utils/VisitUtils';

const getVisitColor = (visitStatus, alert, useAlertColor = false) => {
    if (visitStatus === VisitStatusEnum.Completed && !useAlertColor) {
        return 'cool-green';
    } else if (visitStatus === VisitStatusEnum.Cancelled && !useAlertColor) {
        return 'salmon-two';
    } else if (!useAlertColor) {
        return VisitUtils.getVisitColor(visitStatus).name;
    } else if (alert) {
        return 'salmon';
    } else {
        switch (visitStatus) {
            case VisitStatusEnum.Travelling:
                return 'azure';
            case VisitStatusEnum.Transacting:
                return 'azure';
            case VisitStatusEnum.Queued:
                return 'dusk-blue';
            case VisitStatusEnum.Completed:
                return 'cool-green';
            case VisitStatusEnum.Cancelled:
                return 'salmon-two';
            case VisitStatusEnum.Waiting:
                return 'slate-grey';
            default:
                return 'slate-grey';
        }
    }
};

const getTaskColor = ({ taskStatus, alert, useAlertColor = false }) => {
    if (taskStatus === 'COMPLETED' && !useAlertColor) {
        return 'cool-green';
    } else if (taskStatus === 'CANCELLED' && !useAlertColor) {
        return 'salmon-two';
    } else if (alert) {
        return 'salmon';
    } else {
        switch (taskStatus) {
            case TaskStatus.ONGOING:
                return dashboardColors.azure.name;
            case TaskStatus.COMPLETED:
                return dashboardColors.coolGreen.name;
            case TaskStatus.CANCELLED:
                return dashboardColors.salmonTwo.name;
            case TaskStatus.WAITING:
                return dashboardColors.slateGrey.name;
            default:
                return dashboardColors.slateGrey.name;
        }
    }
};

const getVisitIconClass = (visitType, breakType = null, isV2 = false) => {
    switch (visitType) {
        case 'PICKUP':
            return 'pickup-icon';
        case 'DROP':
            return 'drop-icon';
        case 'HOMEBASE':
            return 'homebase';
        case 'CUSTOMER':
            return 'customer';
        default:
            return !isV2
                ? 'service-icon'
                : getUserVisitIconClass(visitType, breakType, isV2);
    }
};

const getMarkerColorFromConfidence = (confidence, showMedium) => {
    switch (confidence) {
        case 'LOW':
            return 'salmon-two';
        case 'MEDIUM':
            return showMedium ? 'salmon' : 'dark-sky-blue';
        case 'HIGH':
            return 'dark-sky-blue';
        default:
            return 'salmon-two';
    }
};

const getUserVisitColor = userVisitType => {
    if (userVisitType === UserVisitTypeEnum.Break) return 'mango';
    return 'dark-sky-blue';
};

const getUserVisitIconClass = (userVisitType, breakType, isV2 = false) => {
    switch (userVisitType) {
        case UserVisitTypeEnum.ShiftStart:
            return isV2 ? 'circle' : 'flagMarker';
        case UserVisitTypeEnum.ShiftEnd:
        case UserVisitTypeEnum.TourEnd:
            return isV2 ? 'square' : 'pinMarker';
        case UserVisitTypeEnum.Service:
            return 'service-icon';
        case UserVisitTypeEnum.Break:
            switch (breakType) {
                case BreakTypeEnum.Lunch:
                    return 'coffee-cup';
                case BreakTypeEnum.Refuel:
                    return 'refuel';
                case BreakTypeEnum.Night:
                    return 'night';
                default:
                    return 'alert';
            }
        case UserVisitTypeEnum.Other:
            return 'pause';
        case UserVisitTypeEnum.None:
            return 'pause';
        case UserVisitTypeEnum.StartOfDay:
            return 'flagMarker';
        case UserVisitTypeEnum.EndOfDay:
            return 'pinMarker';
        default:
            return 'pause';
    }
};

export {
    getVisitColor,
    getTaskColor,
    getVisitIconClass,
    getMarkerColorFromConfidence,
    getUserVisitIconClass,
    getUserVisitColor
};
